import React from "react";
import PropTypes from "prop-types";
import Badge from "antd/es/badge";
import Card from "antd/es/card";
import Col from "antd/es/col";
import Divider from "antd/es/divider";
import Row from "antd/es/row";
import DetailsColumn from "./DetailsColumn";
import CountryCodeJSON from "./country_codes.json";

const GuestInformation = ({ transactionRecord, historyDrawer }) => {
  const getOperationData = (currentRecord, field) => {
    if (
      currentRecord &&
      currentRecord.operationData &&
      currentRecord.operationData.length > 0 &&
      currentRecord.operationData[0][field]
    ) {
      return currentRecord.operationData[0][field];
    }
    return "-";
  };

  const getCountryCode = () => {
    const country = getOperationData(transactionRecord, "country_code");
    if (country) {
      const obj = CountryCodeJSON.find((countryObj) => countryObj.code === country.toUpperCase());
      if (obj && obj.dial_code) {
        return obj.dial_code;
      }
    }
    return "";
  };

  const isOperationDataAvailable = (currentRecord, field) => {
    if (
      currentRecord &&
      currentRecord.operationData &&
      currentRecord.operationData.length > 0 &&
      currentRecord.operationData[0][field]
    ) {
      return true;
    }
    return false;
  };

  return (
    <Card style={{ marginTop: "20px", borderColor: "#ffb551" }}>
      <Row type="flex" justify="space-between">
        <Col style={{ paddingTop: "5px" }}>
          <Badge count={"Guest information"} className="details-badge" />
        </Col>
      </Row>

      <div className="left-margin">
        <Row>
          <DetailsColumn
            label={"First name"}
            value={getOperationData(transactionRecord, "first_name")}
          />

          <DetailsColumn
            label={"Last name"}
            value={getOperationData(transactionRecord, "last_name")}
          />
        </Row>
      </div>

      <Divider />

      <div className="left-margin">
        <Row>
          <DetailsColumn
            label={"Email Address"}
            value={historyDrawer ? "-" : getOperationData(transactionRecord, "email")}
            valueStyle={{ textTransform: "none" }}
          />

          <DetailsColumn
            label={"Phone number"}
            value={
              historyDrawer
                ? "-"
                : isOperationDataAvailable(transactionRecord, "phone_number")
                ? `+${getCountryCode()}
                ${getOperationData(transactionRecord, "phone_number")}`
                : "-"
            }
          />
        </Row>
      </div>

      <Divider />

      <div className="left-margin">
        <Row>
          <DetailsColumn
            label={"Total Rooms"}
            value={
              transactionRecord?.operationData?.length > 0 &&
              transactionRecord.operationData[0]["room"]
                ? 1
                : "-"
            }
          />

          <DetailsColumn
            label={"Room"}
            value={getOperationData(transactionRecord, "room")}
          />
        </Row>
      </div>
    </Card>
  );
};


GuestInformation.defaultProps = {
  transactionRecord: {},
};

export default GuestInformation;
